import * as types from '../types'

export default function () {
  return {
    type: types.CLEAR_SENSOR_EVENTS_ROOM,
  }
}
